export const TACTIC_MIN_HEIGHT = 420;
